// src/screens/tabs/Menu/components/CategoryCard.tsx
import React from "react";
import { View, Text } from "react-native";
import { Category, MenuItemType } from "../../types/restaurant.types";
import { menuScreenStyles as styles } from "../../styles/styles";
import { SubCategorySection } from "./SubCategorySection";

interface CategoryCardProps {
  category: Category;
  onAddToCart: (item: MenuItemType, quantity: number) => void;
}

export const CategoryCard: React.FC<CategoryCardProps> = ({
  category,
  onAddToCart,
}) => {
  return (
    <View style={styles.categoryCard}>
      <Text style={styles.categoryTitle}>{category.name}</Text>
      {Object.values(category.subCategories).map((subCategory) => (
        <SubCategorySection
          onAddToCart={onAddToCart}
          key={subCategory.name}
          subCategory={subCategory}
        />
      ))}
    </View>
  );
};
